export const ProductStatus = {
  NOT_MARKETED: "Non commercialisé",
  MARKETED: "Commercialisé"
};

export const getProductStatusOptions = () => {
  return [
    { value: "", label: "Tous les statuts" },
    ...Object.entries(ProductStatus).map(([key, label]) => ({
      value: key,
      label,
    })),
  ];
};
